import { useReviews } from "@/hooks/usePublicData";
import { SectionHeading, Stars } from "@/components/ui-bits";
import { Quote } from "lucide-react";

export default function ReviewsSection() {
  const { data: reviews = [] } = useReviews();
  return (
    <section className="section-pad bg-brand-light/50" data-testid="reviews-section">
      <div className="container-x">
        <SectionHeading center eyebrow="Testimonials" title="What Our Customers Say"
          subtitle="Real feedback from travellers who trusted Chouhan Taxi Service for their Rajasthan journeys." />
        {reviews.length === 0 ? (
          <div className="text-center max-w-lg mx-auto bg-white rounded-2xl border border-slate-200 p-10">
            <Quote className="w-10 h-10 text-brand mx-auto mb-4" />
            <p className="text-slate-600">We are building our collection of customer reviews. Travelled with us? We would love to hear about your experience — call us at <span className="font-semibold text-navy">099829 03736</span>.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((r) => (
              <div key={r.id} className="bg-white rounded-2xl border border-slate-100 p-6 shadow-sm card-hover" data-testid={`review-${r.id}`}>
                <Quote className="w-8 h-8 text-brand/30 mb-3" />
                <Stars n={r.rating || 5} />
                <p className="text-slate-600 mt-3 leading-relaxed">"{r.text}"</p>
                <div className="mt-4 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-navy text-white flex items-center justify-center font-semibold">{(r.name || "?")[0]}</div>
                  <div>
                    <div className="font-semibold text-navy-heading text-sm">{r.name}</div>
                    {r.location && <div className="text-xs text-slate-400">{r.location}</div>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
